export default {
  items: [
    {
      name: "대시보드",
      url: "/dashboard",
      icon: "fas fa-tv",
      iconArr: "",
      class: "miw150",
      selChildName: "", // HICC230125: 선택한 Child 메뉴명
    },
    {
      name: "센서 정보",
      url: "/sensorDetailInfo",
      icon: "fas fa-list-alt",
      iconArr: "",
      class: "miw150",
      selChildName: "", // HICC230125: 선택한 Child 메뉴명
      children: [
        {
          name: "센서 정보",
          url: "/sensorDetailInfo",
        },
      ],
    },
    {
      name: "센서 데이터",
      url: "/sensorDataChart",
      icon: "fas fa-chart-area",
      iconArr: "",
      class: "miw165",
      selChildName: "", // HICC230125: 선택한 Child 메뉴명
      children: [
        {
          name: "데이터 조회",
          url: "/sensorDataChart",
        },
        {
          name: "RAWFILE 조회",
          url: "/rawfileData",
        },
        {
          name: "임계치 이벤트 이력",
          url: "/dataThreshold",
        },
        {
          name: "계측 데이터 조회(시계열)",
          url: "/measurementData",
        },
      ],
    },
    {
      name: "정적 분석",
      url: "/trendAnalysis",
      icon: "fas fa-chart-line",
      iconArr: "",
      class: "miw150",
      selChildName: "", // HICC230125: 선택한 Child 메뉴명
      children: [
        {
          name: "트랜드 분석",
          url: "/trendAnalysis",
        },
      ],
    },
    {
      name: "동적 분석",
      url: "/analysisChart",
      icon: "fas fa-chart-line",
      iconArr: "",
      class: "miw150",
      selChildName: "", // HICC230125: 선택한 Child 메뉴명
      children: [
        {
          name: "AvgFFT",
          url: "/analysisChart",
        },
        {
          name: "SSI",
          url: "/ssiAnalysis",
        },
        {
          name: "SSI Octave",
          url: "/ssiAnalysisOctave",
        },
        {
          name: "IF(F-D table)",
          url: "/loadCarryingCapacityAnalysis",
        },
        {
          name: "FRF",
          url: "/frequencyResponseFunction",
        },
      ],
    },
    {
      name: "분석 이력",
      url: "/analysisHistory",
      icon: "fas fa-history",
      iconArr: "",
      class: "miw150",
      selChildName: "", // HICC230125: 선택한 Child 메뉴명
      children: [
        {
          name: "분석 이력",
          url: "/analysisHistory",
        },
      ],
    },
    {
      name: "보고서",
      url: "/report",
      icon: "fas fa-file-pdf-o",
      iconArr: "",
      class: "miw120",
      selChildName: "", // HICC230125: 선택한 Child 메뉴명
      children: [
        {
          name: "보고서",
          url: "/report",
        },
      ],
    },
    {
      name: "현장사진",
      url: "/scenePhoto",
      icon: "fas fa-photo-video",
      iconArr: "",
      class: "miw105",
      selChildName: "", // HICC230125: 선택한 Child 메뉴명
      children: [
        {
          name: "현장사진",
          url: "/scenePhoto",
        },
      ],
    },
    /** 3d test -kyj */
    // {
    //   name: 'Test-3D',
    //   url: '/test3dkyj',
    //   icon: 'fas fa-atom',
    //   iconArr: '',
    //   class: 'miw105',
    //   children: []
    // }
    /** 3d test -kyj */
    /* ,
    {
      name: '분석 테스트',
      url: '/analysisTest',
      icon: 'fas fa-search',
      iconArr: '',
      class: 'miw160',
      children: []
    },
    {
      name: '관리',
      url: '/customerManage',
      class: 'miw150',
      iconArr: '',
      children: [
        {
          name: '고객관리',
          url: '/customerManage'
        }
      ]
    } */
  ],
};



// WEBPACK FOOTER //
// ./src/_nav.js